// User roles enum - matches Identity Server arconnect_role claim values
export enum Role {
  NONE = '',
  ADMIN = 'Admin',
  SYS_ADMIN = 'SysAdmin',
  INFLUENCER = 'Influencer',
  PARTICIPANT = 'Participant',
}

// User data interface
export interface UserData {
  userId: string;
  name: string;
  email: string;
  role: Role; // ARConnect role from Identity Server (ADMIN, INFLUENCER, or NONE)
  siteIds: string[]; // Array of site IDs the user has access to
  currentSiteId?: string; // Currently selected site
  membershipUserId?: string; // Identity server user ID
  analystId?: number; // ARchitect analyst ID (for Matomo tracking)
  firmId?: number; // Firm ID (for Matomo tracking)
  firmName?: string; // Firm name (for Pendo tracking)
  intercomHMAC?: string; // Intercom user hash for secure identity verification
}
